<div class="flex flex-col">
  <div class="flex flex-row">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
            'bg-gray-600': sharedService.userTheme === 'dark',
            'bg-indigo-50': sharedService.userTheme === 'light'}">
            
      <div class="flex flex-row items-center">
        <div class="flex flex-row w-full">
          <div class="flex flex-row">
            <p><b>Changes: </b>{{changes.length}} </p>
          </div>
        </div>

        <div class="float-right">
          <button mat-icon-button matTooltip="Refresh" (click)="getChangeLog()"
            [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">refresh</mat-icon> 
          </button>
        </div>
      </div>
    </mat-card>
  </div>
 
  <div class="flex flex-row">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
    'bg-gray-600': sharedService.userTheme === 'dark',
    'bg-indigo-50': sharedService.userTheme === 'light'}">
      <mat-card-content>
        <div class="flex flex-col" *ngIf="changes.length > 0">
          <div class="flex flex-row">
            <mat-form-field class="w-1/4">
              <input matInput id="listFilter" (keyup)="filterTable($event)" placeholder="Filter"
                value="{{listFilter}}" />

              <button *ngIf="listFilter" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>

          <div style="overflow-x:auto">
            <div class="flex flex-row">
              <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #TableSort="matSort"
                class="mat-elevation-z8 w-full">
                <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
                  <td mat-cell *matCellDef="let change">{{change.type}}</td>
                </ng-container>
                <ng-container matColumnDef="oldValue">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Old Value</th>
                  <td mat-cell *matCellDef="let change">{{change.oldValue}}</td>
                </ng-container>
                <ng-container matColumnDef="newValue">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>New Value</th>
                  <td mat-cell *matCellDef="let change">{{change.newValue}}</td>
                </ng-container>
                <ng-container matColumnDef="dateChanged">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Changed</th>
                  <td mat-cell *matCellDef="let change">{{change.dateChanged}}</td>
                </ng-container>
                <ng-container matColumnDef="changedBy">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Changed By</th>
                  <td mat-cell *matCellDef="let change">{{change.changedBy}}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" ></tr>
              </table>
            </div>
          </div>
          <mat-paginator [pageSizeOptions]="getPageSizeOptions()" #TablePaginator="matPaginator" showFirstLastButtons>
          </mat-paginator>
        </div>

      </mat-card-content>

    </mat-card>
  </div>
</div>
